export const DATE_FILTER_NAMES = {
  DASHBOARD: 'dashboard',
  DEALERSHIP_LEADS: 'dealershipleads',
  LEADS: 'leads',
  MY_LEADS: 'myleads',
};
